import { IState } from 'shared/store';

export const selectBrochure = (state: IState) => {
  return state.offerData.newObject?.brochure;
};
